module.exports = __webpack_public_path__ + "img/logo_announcement.a49b69a1.png";